/** Words the shared table uses when its rows are ITEMS rather than subitems. */
export const ITEM_LABELS = {
  first: 'Item',
  add: '+ Add item',
  placeholder: 'Write an item name',
  deleteRow: 'Delete item',
};

/** The subitem bubble by each item's name (the item's subitem count). */
export const subitemsBadge = {
  count: (row) => (row.subitems || []).length,
};
